module.exports = __webpack_public_path__ + "img/products_big_can_sugar.39048f88.png";